import React, { PropsWithChildren } from 'react';
import ButtonBase from './ButtonBase';

interface ButtonProps {
  onClick: CallableFunction;
  disabled?: boolean;
  rounded?: boolean;
  className?: string;
  outline?: boolean;
  gray?: boolean;
  whatsapp?: boolean;
  withLoading?: boolean;
  type?: 'button' | 'submit' | 'reset' | undefined;
}

const Button = ({
  children,
  onClick = () => {},
  disabled = false,
  rounded = false,
  className,
  outline = false,
  gray = false,
  whatsapp = false,
  type = 'button',
  withLoading

}: PropsWithChildren<ButtonProps>) => {

  const handleClick = () => {
    onClick()
  }

  return (
    <ButtonBase
      type={type}
      onClick={handleClick}
      disabled={disabled}
      rounded={rounded}
      withLoading={withLoading}
      className={`
        ${className}
        ${gray ? 'bg-gray-50 ring-transparent' : ''}
        ${whatsapp ? 'ring-2 ring-green-500 hover:ring-green-400 bg-white/75 hover:bg-white/80 hover:backdrop-blur-sm' : ''}
        ${outline ? 'ring-gray-400 hover:ring-gray-300' : 'ring-gray-300 hover:ring-gray-400 hover:bg-gray-50 '}
    `}>
      {children}
    </ButtonBase>
  )
}

export default Button;